module.exports = __webpack_public_path__ + "img/街道夜.64db7b27.png";